import styles from "./Infographic.module.scss";

const Infographic = (props) => {
  const { children, title } = props;
  return (
    <div className={styles["Infographic"]}>
      <div className={styles["Infographic__title"]}>{title}</div>
      {children}
    </div>
  );
};

export default Infographic;
